export const messages_tr = {
    nameEmpty: "İsim alanı boş bırakılamaz",
    emailEmpty: "Email adresi boş bırakılamaz",
    emailNotValid: "Geçersiz email, lütfen doğru bir adres girin",
    locationEmpty: "Lokasyon boş bırakılamaz",
    interests: "3 ilgi alanı seçiniz",
    profileSaved: "Profil ayarlari kaydedildi",
    profilePic: "Profil resmi kaydedildi",
    addToFavorites:"Favorilere başarıyla eklendi",
    removeFromFavorites:"Favorilerden başarıyla kaldırıldı"
};  


// WEBPACK FOOTER //
// ./src/constants/messages_tr.js